import { render, staticRenderFns } from "./licenseInfo.vue?vue&type=template&id=5461a1bc"
import script from "./licenseInfo.vue?vue&type=script&lang=js"
export * from "./licenseInfo.vue?vue&type=script&lang=js"
import style0 from "./licenseInfo.vue?vue&type=style&index=0&id=5461a1bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports